import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lookup-master-add',
  templateUrl: './lookup-master-add.component.html',
  styleUrls: ['./lookup-master-add.component.css']
})
export class LookupMasterAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
